/**
 * Listen for height changes reported by iframes.
 *
 * Example trigger:
 * setTimeout(function() {
 *     if (window.parent) {
 *         window.parent.postMessage( {
 *             height: document.body.scrollHeight,
 *             message: 'resize:height'
 *         }, '*' );
 *     }
 * }, 500);
 */
export default function iframeListener() {
  let iframes = [];

  const listeningFrames = [];

  const handleMessage = (e) => {
    if ('resize:height' === e.data.message && e.data.height) {
      const i = listeningFrames.indexOf(e.source);

      if (0 <= i && 'object' === typeof iframes[i]) {
        iframes[i].height = e.data.height;
      }
    }
  };

  // Map iframes to their content window objects.
  iframes = document.getElementsByTagName('iframe');
  for (let i = 0; i < iframes.length; i += 1) {
    listeningFrames.push(iframes[i].contentWindow);
  }

  // Listen for resize postMessages.
  window.addEventListener('message', handleMessage, false);
}
